// All roles that exist, allowed or not to login to the admin website:
export const RolesKey = [
  // administrative roles:
  'admin',
  'client_editor',
  'client_viewer',
  'external',
] as const;

export type Roles = typeof RolesKey[number];

export const AdminRole: Roles = 'admin';

// Roles allowed to login in the admin website:
export const RolesAdministrative: Array<Roles> = [
  'admin',
  'client_editor',
  'client_viewer',
  'external',
  // BEWARE! more than 10 admin roles will bring problems in firestore query: array-contains-any
];
